import styles from './expandable-menu.module.css';

import * as React from 'react';
import { NavigationMenu } from 'radix-ui';
import { CaretDownIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex } from '@radix-ui/themes';
import NavItem from '../navigation/nav-item';
import { BranchWithParsedCases } from '@/app/lib/schemas/types/branch-types';

interface Props {
  items: Array<BranchWithParsedCases & { layoutClassName: string }>;
  currentTopicSlug: string | undefined;
  onBeforeNavigate: () => void;
}

export default function ExpandableMenu({
  items,
  currentTopicSlug,
  onBeforeNavigate
}: Props) {
  return (
    <NavigationMenu.Root className={styles.Root}>
      <NavigationMenu.List className={styles.MenuList}>
        {!!items &&
          items.map(item => (
            <NavigationMenu.Item key={item.slug}>
              <NavigationMenu.Trigger asChild>
                <Flex
                  align='center'
                  gap='1'
                >
                  <Button variant='ghost'>{item.name}</Button>
                  <CaretDownIcon
                    className={styles.CaretDown}
                    aria-hidden
                  />
                </Flex>
              </NavigationMenu.Trigger>
              <NavigationMenu.Content>
                <Card className={styles.Card}>
                  <ul className={`${styles.List} ${item.layoutClassName}`}>
                    {item.topics.map(topic => (
                      <NavItem
                        key={topic.slug}
                        href={`/${item.slug}/${topic.slug}`}
                        isActive={topic.slug === currentTopicSlug}
                        onBeforeNavigate={onBeforeNavigate}
                        label={topic.name}
                      />
                    ))}
                  </ul>
                </Card>
              </NavigationMenu.Content>
            </NavigationMenu.Item>
          ))}

        <NavigationMenu.Indicator className={styles.Indicator}>
          {/* <div className={styles.Arrow} /> */}
        </NavigationMenu.Indicator>
      </NavigationMenu.List>

      <div className={styles.ViewportPosition}>
        <NavigationMenu.Viewport className={styles.Viewport} />
      </div>
    </NavigationMenu.Root>
  );
}
